import React from 'react';
import { Box, BoxProps } from '../../../../../../CommonComponents/OPL/Box/Box';

export const FieldsGrid = ({ children, ...rest }: React.PropsWithChildren<BoxProps>) => (
  <Box
    display="grid"
    width="100%"
    css={({ theme }) => ({
      gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
      gap: theme.space['12'],
    })}
    {...rest}
  >
    {children}
  </Box>
);
